/**
 * Метод загрузки модуля для добаления механизмка кластеризщации.
 *
 * Использование кластера помогает отобразить на карте большое количество маркеров.
 * При увеличении масштаба карты отдельные маркеры объединяются в кластер.
 * При уменьшении масштаба карты кластер распадается на отдельные маркеры.
 *
 * @kind helper
 * @returns Промис получения пакета
 */
export const loadClusterer = () => ymaps3.import('@yandex/ymaps3-clusterer@0.0.1');
